module.exports = __webpack_public_path__ + "img/Relatable.eed7fa38.png";